<template>
  <div class="flex flex-col space-y-2">
    <div
      v-for="{ id, customData, productId } in automaticDiscountPromotions"
      v-show="shouldShowAutomaticDiscountBanner(productId)"
      :key="`automatic-discount-banner-${id}`"
      class="rounded-md px-4 py-3 text-xs"
      :style="getPromotionStyle(customData)"
    >
      <Headline
        tag="h2"
        size="xs"
        class="text-balance lg:basis-5/12 xl:basis-7/12"
      >
        <p>{{ $t('promotion.hurry_to_save') }}</p>
      </Headline>
    </div>
    <div
      v-for="{ id, customData } in buyXGetYPromotions"
      v-show="shouldShowBuyXGetYBanner(customData?.product?.promotionId)"
      :key="`buy-x-get-y-banner-${id}`"
      class="rounded-md px-4 py-3 text-xs"
      :style="getPromotionStyle(customData)"
    >
      <Headline
        tag="h2"
        size="xs"
        class="text-balance lg:basis-5/12 xl:basis-7/12"
      >
        {{ $t('promotion.save_your_free_gift') }}
      </Headline>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'

const props = withDefaults(defineProps<{ product?: Product }>(), {
  product: undefined,
})

const route = useRoute()
const localePath = useLocalePath()

const { buyXGetYPromotions, automaticDiscountPromotions } =
  await useBasketPromotions()

const { productPromotionId } = await useProductPromotions(props.product)

const isBasketPage = computed(() => {
  return route.path === localePath(routeList.basket)
})

const shouldShowAutomaticDiscountBanner = (productId: number) => {
  return isBasketPage.value || productId === props.product?.id
}

const shouldShowBuyXGetYBanner = (promotionId?: number) => {
  return isBasketPage.value || promotionId === productPromotionId.value
}
</script>
